import { PureComponent } from 'react';
import { Field } from 'react-final-form';
import { SpotFieldError } from '@enterprise/spot';
import { Trans } from 'react-i18next';
import i18n from '../../../i18n';
import { isEmail } from 'validator';
import classNames from 'classnames';

export class UserStep extends PureComponent {
    render() {
        return (
            <div>
                <div className="spot-typography__heading--level-3">
                    <Trans i18nKey="common:signUp.userStepTitle">Let's setup your account</Trans>
                </div>
                <div className="spot-typography__heading--level-4">
                    <Trans i18nKey="common:signUp.enterName">Please enter your name</Trans>
                </div>

                <Field
                    name="profileFirstName"
                    validate={(value) =>
                        value
                            ? undefined
                            : i18n.t('validation:isNotEmpty', {
                                  field: i18n.t('common:signUp.firstName'),
                                  defaultValue: 'First name should not be empty',
                              })
                    }
                >
                    {({ input, meta }) => (
                        <div className={classNames('spot-form__field-group', { 'spot-form--error': Boolean(meta?.error && meta?.touched) })}>
                            <label className="spot-form__label">
                                <Trans i18nKey="common:signUp.firstName">First name</Trans>
                            </label>
                            <input className="spot-form__input" type="text" {...input} />
                            <SpotFieldError meta={meta} />
                        </div>
                    )}
                </Field>
                <Field
                    name="profileLastName"
                    validate={(value) =>
                        value
                            ? undefined
                            : i18n.t('validation:isNotEmpty', {
                                  field: i18n.t('common:signUp.lastName'),
                                  defaultValue: 'Last name should not be empty',
                              })
                    }
                >
                    {({ input, meta }) => (
                        <div className={classNames('spot-form__field-group', { 'spot-form--error': Boolean(meta?.error && meta?.touched) })}>
                            <label className="spot-form__label">
                                <Trans i18nKey="common:signUp.lastName">Last name</Trans>
                            </label>
                            <input className="spot-form__input" type="text" {...input} />
                            <SpotFieldError meta={meta} />
                        </div>
                    )}
                </Field>
                <Field
                    name="username"
                    validate={(value) =>
                        value && isEmail(value) ? undefined : i18n.t('validation:isNotEmail', 'Please enter a valid email address')
                    }
                >
                    {({ input, meta }) => (
                        <div className={classNames('spot-form__field-group', { 'spot-form--error': Boolean(meta?.error && meta?.touched) })}>
                            <label className="spot-form__label">
                                <Trans i18nKey="common:signUp.email">Email</Trans>
                            </label>
                            <input className="spot-form__input" type="text" {...input} />
                            <SpotFieldError meta={meta} />
                        </div>
                    )}
                </Field>
            </div>
        );
    }
}
